import type { CurrentUser } from '@gamble-chess/contracts';
import type { JSX } from 'react';

import { useSignOut } from '../api/auth.ts';
import { Alert } from '../ui/Alert.tsx';
import { secondaryButtonClass } from '../ui/styles.ts';

/** Who is signed in, and the way out. */
export function AccountMenu({ user }: { readonly user: CurrentUser }): JSX.Element {
  const signOut = useSignOut();
  const leaving = signOut.isPending || signOut.isSuccess;

  return (
    <div className="flex flex-col items-end gap-1">
      <div className="flex items-center gap-3">
        <span className="text-sm text-ink-muted">
          <span className="hidden sm:inline">Signed in as </span>
          <strong data-testid="current-user">{user.displayName}</strong>
        </span>
        <button
          type="button"
          onClick={() => {
            signOut.mutate();
          }}
          disabled={leaving}
          className={secondaryButtonClass}
        >
          {leaving ? 'Signing out…' : 'Sign out'}
        </button>
      </div>
      {signOut.isError ? <Alert>Sign out failed. Please try again.</Alert> : null}
    </div>
  );
}
